<app-grid
    [selectBy]="itemIdentifier"
    [data]="displayData"
    [cols]="columns"
    [buttons]="gridButtons"
    [selectable]="{
        enabled: true,
        mode: 'single',
        checkboxOnly: true
    }"
    [selection]="selectedIds"
    [filterable]="false"
    [reorderable]="false"
    [allowGridSave]="false"
    [showColumnSelector]="false"
    [applyLocalPagination]="true"
    (selectedKeysChange)="onSelectedIdsChange($event)" />
